import { render, staticRenderFns } from "./MeusDados.vue?vue&type=template&id=30c91ca1&scoped=true&"
import script from "./MeusDados.vue?vue&type=script&lang=js&"
export * from "./MeusDados.vue?vue&type=script&lang=js&"
import style0 from "./MeusDados.vue?vue&type=style&index=0&id=30c91ca1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c91ca1",
  null
  
)

export default component.exports